import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AnomaliaList, AnomalyService, IDetalhesAnomalia } from '../../../../../services/api/anomaly/AnomalyService';
import { LayoutBase } from '../../../../../layouts';
import { PlanAndSections, ToolsDetails } from '../../../../../components/custom';
import { CustomAlert, VMenu } from '../../../../../components/shared';
import { Box, Card, Divider, FormControl, InputLabel, LinearProgress, MenuItem, Select, TextField, Typography } from '@mui/material';
import { IActionPlanData, PlanosDeAcaoService } from '../../../../../services/api/planosDeAcao/PlanosDeAcaoService';
import { Controller, useForm } from 'react-hook-form';

const defaultValues: IActionPlanData = {
    acao: '',
    codigo_anomalia: '',
    dataRelatorioInspecao: '',
    descricao: '',
    descricaoAnomalia: '',
    id_anomalia: '',
    npa: '',
    data_limite_seguranca: '',
    finalizado: false,
    responsavel_principal: '',
    uuid: '',
    status: 'NAO INICIADO'
};

export default function ActionPlan() {

    const { id, anomaly } = useParams();
    const navigate = useNavigate();

    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success',
    });

    const [dataAnomalia, setDataAnomalia] = useState<IDetalhesAnomalia | null>(null);
    const [loadingAnomalia, setLoadingAnomalia] = useState<boolean>(true);
    type FormSchema = IActionPlanData;
    const { register, handleSubmit, formState, control, setValue } = useForm<FormSchema>({ defaultValues });

    async function fetchData(uuid_anomalia: string) {
        setLoadingAnomalia(true);
        try {
            const res = await AnomalyService.get(uuid_anomalia);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao buscar dados !', severity: 'warning' });
            }
            const data = res.detalhes as IDetalhesAnomalia;
            console.log('teste', data);
            data.data_inspecao = data.data_inspecao.split(' ')[0];
            setValue('npa', data.npa);
            setValue('origem', data.origem);
            setValue('codigo_anomalia', data.codigo_anomalia || '');
            setDataAnomalia(data);
            setLoadingAnomalia(false);
        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao buscar dados !', severity: 'warning' });
        }
    }

    async function submitPlano(data: IActionPlanData) {
        try {
            const res = await PlanosDeAcaoService.create(anomaly ? anomaly : '', data);
            if (res instanceof Error) {
                setAlertInfo({ open: true, message: 'Erro ao cadastrar !', severity: 'warning' });
            }
            setAlertInfo({ open: true, message: 'Plano de ação salvo !', severity: 'success' });
            setTimeout(() => {
                navigate(-1);
            }, 1000);

        } catch (error) {
            setAlertInfo({ open: true, message: 'Erro ao cadastrar !', severity: 'warning' });
        }
    }

    useEffect(() => {
        anomaly && fetchData(anomaly);
    }, []);

    return (
        <LayoutBase
            title='Cadastro de plano de ação'
            tollBar={
                <ToolsDetails
                    onClickSave={handleSubmit(submitPlano)}
                    showNewButton={false}
                    showDeletButton={false}
                />
            }
        >
            <VMenu id={id} />
            <Box>
                {loadingAnomalia && (
                    <Box sx={{ padding: 2, margin: 2 }}>
                        <LinearProgress />
                    </Box>
                )}

                <Card sx={{ boder: '2px #ccc solid', borderRadius: 3, padding: 2 }}>
                    <form id='plano'>
                        <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 2 }}>
                            <Box sx={{ gridColumn: 'span 2' }}>
                                <Typography variant='h5'>Cadastrar plano de ação</Typography>
                                <Divider />
                            </Box>
                            <TextField
                                value={dataAnomalia?.item}
                                label='Localização da anomalia'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ bgcolor: '#cccccc21' }}
                            />
                            <TextField
                                value={dataAnomalia?.data_inspecao}
                                label='Data de inspeção'
                                type='date'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                sx={{ bgcolor: '#cccccc21' }}
                            />
                            <TextField
                                value={dataAnomalia?.observacoes_gerais}
                                label='Descrição da anomalia'
                                fullWidth
                                multiline
                                rows={2}
                                InputLabelProps={{ shrink: true }}
                                sx={{ bgcolor: '#cccccc21' }}
                            />
                            {/* <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gap: 2 }}>
                                <TextField
                                    label='Código de identificação da anomalia'
                                    // disabled
                                    helperText='Código gerado ao criar anomalia'
                                    InputLabelProps={{ shrink: true }}
                                    value={dataAnomalia?.codigo_anomalia}
                                    sx={{ color: '#cccccc21' }}
                                // {...register('codigo_anomalia', { required: false })}
                                />
                            </Box> */}
                            <TextField
                                label='Código de identificação da anomalia'

                                InputLabelProps={{ shrink: true }}
                                // value={dataAnomalia?.codigo_anomalia}
                                // sx={{ color: '#cccccc21' }}
                                helperText='Código gerado ao criar anomalia'
                                {...register('codigo_anomalia', { required: false })}
                            />
                            <TextField
                                label='Data limite de segurança'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                type='date'
                                error={!!formState.errors.data_limite_seguranca}
                                helperText={formState.errors.data_limite_seguranca && 'Campo obrigatório'}
                                {...register('data_limite_seguranca', { required: true })}
                            />
                            <FormControl fullWidth error={!!formState.errors.acao}>
                                <InputLabel>Natureza da Ação</InputLabel>

                                <Controller
                                    name="acao"
                                    control={control}
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({ field }) => (
                                        <Select {...field} label="Ação">
                                            <MenuItem value="MC - Monitoramento/Controle">MC - Monitoramento/Controle</MenuItem>
                                            <MenuItem value="CL - Conservação/Limpeza">CL - Conservação/Limpeza</MenuItem>
                                            <MenuItem value="PJ - Projetos de Engenharia">PJ - Projetos de Engenharia</MenuItem>
                                            <MenuItem value="SE - Serviço de engenharia">SE - Serviço de engenharia</MenuItem>
                                            <MenuItem value="ES - Engenharia especializada">ES - Engenharia especializada</MenuItem>
                                            <MenuItem value="EL - Eletromecânica">EL - Eletromecânica</MenuItem>
                                        </Select>
                                    )}
                                />
                            </FormControl>
                            <TextField
                                label='Responsável técnico'
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                error={!!formState.errors.responsavel_principal}
                                helperText={formState.errors.responsavel_principal && 'Campo obrigatório'}
                                {...register('responsavel_principal', { required: true })}
                            />
                            <TextField
                                label='Observação do plano de ação'
                                fullWidth
                                multiline
                                rows={2}
                                sx={{ gridColumn: 'span 2' }}
                                InputLabelProps={{ shrink: true }}
                                {...register('descricao', { required: false })}
                            />
                        </Box>
                    </form>
                </Card>
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    message={alertInfo.message}
                    severity={alertInfo.severity}
                    key={alertInfo.message}
                />
            }
        </LayoutBase>
    );
}